module.exports = __webpack_public_path__ + "static/media/107-kwait.3243b39e.svg";